import KpiCard from '../../components/admin/KpiCard';
import useAdminData from './useAdminData';
import { fetchBlockedStats } from '../../services/adminStatsService';

export default function AdminBlocked() {
  const { data, loading, error } = useAdminData(fetchBlockedStats);

  if (loading) return <div className="text-gray-500">Loading…</div>;
  if (error) return <div className="text-red-600">{error}</div>;
  if (!data) return null;

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-3">
        <KpiCard label="Total blocked contacts" value={data.totalContacts} icon="🚫" />
        <KpiCard label="Blocked attempts in range" value={data.attemptsInRange} icon="⛔" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="bg-white rounded-lg border border-gray-200">
          <h3 className="text-sm font-semibold text-gray-700 px-4 py-3 border-b border-gray-200">Top blockers</h3>
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-xs text-gray-500 uppercase">
              <tr>
                <th className="px-3 py-2 text-left">Agent</th>
                <th className="px-3 py-2 text-right">Blocks</th>
              </tr>
            </thead>
            <tbody>
              {(data.topBlockers || []).map((r, i) => (
                <tr key={`${r.userId}-${i}`} className="border-t border-gray-100">
                  <td className="px-3 py-2">{r.name || '—'}</td>
                  <td className="px-3 py-2 text-right">{r.count.toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="bg-white rounded-lg border border-gray-200">
          <h3 className="text-sm font-semibold text-gray-700 px-4 py-3 border-b border-gray-200">Top reasons</h3>
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-xs text-gray-500 uppercase">
              <tr>
                <th className="px-3 py-2 text-left">Reason</th>
                <th className="px-3 py-2 text-right">Count</th>
              </tr>
            </thead>
            <tbody>
              {(data.topReasons || []).map((r, i) => (
                <tr key={i} className="border-t border-gray-100">
                  <td className="px-3 py-2">{r.reason}</td>
                  <td className="px-3 py-2 text-right">{r.count.toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
